export default "__VITE_ASSET__k$S2wRvT__";